import { ConstantValues } from "common/constants";
import { RichTextToolBar } from "components/richTextToolbar/RichTextToolbar";
import { useCallback, useEffect, useMemo, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import { ICellProps } from "./Cell.types";
import { useRichTextFieldStyles } from "./RichTextFieldCell.styles";

const Font = Quill.import("formats/font");
Font.whitelist = ["sans-serif", "serif", "monospace", "cursive", "fantasy"];
Quill.register(Font, true);

export const formats: Array<string> = [
  "list",
  "bullet",
  "ordered",
  "bold",
  "italic",
  "underline",
  "link",
];

export const RichTextField = (props: ICellProps): JSX.Element => {
  const styles = useRichTextFieldStyles();
  const [convertedText, setConvertedText] = useState<string>(
    ConstantValues.EMPTY_STRING,
  );
  const [toolbarId] = useState<string>(
    () => `toolbar-${crypto.getRandomValues(new Uint32Array(1))[0] % 1000000}`,
  );

  useEffect((): void => {
    setConvertedText(props.value ?? ConstantValues.EMPTY_STRING);
  }, [props.value]);

  const onChange = useCallback(
    (content: any): void => {
      setConvertedText(content);
      if (content) {
        props.onChange(undefined, content);
      }
    },
    [props.onChange],
  );

  const modules = useMemo(
    () => ({
      toolbar: { container: `#${toolbarId}` },
      clipboard: { matchVisual: false },
    }),
    [toolbarId],
  );

  return (
    <div className={styles.container}>
      <RichTextToolBar toolbarId={toolbarId} />
      <div className={styles.editorWrapper}>
        <ReactQuill
          className={styles.editor}
          onKeyDown={(e: any): void => e.stopPropagation()}
          theme="snow"
          value={convertedText || ConstantValues.EMPTY_STRING}
          onChange={onChange}
          modules={modules}
          formats={formats}
        />
      </div>
    </div>
  );
};
